import { Link } from 'react-router-dom'

// Slim pre-launch footer: brand + socials + legal only. No site nav.
export default function LaunchFooter() {
  const link = { fontFamily:'Nunito Sans, sans-serif', fontSize:'0.82rem', color:'rgba(255,255,255,0.6)', textDecoration:'none' }
  return (
    <footer style={{ background:'#1A1A1A', padding:'2.75rem 1.5rem 2.25rem' }}>
      <div style={{ maxWidth:640, margin:'0 auto', textAlign:'center' }}>
        <img src="/okoiya-logo.png" alt="Okoiya" style={{ height:30, objectFit:'contain', filter:'brightness(10)', display:'block', margin:'0 auto 0.75rem' }}/>
        <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.85rem', color:'rgba(255,255,255,0.5)', margin:'0 0 1.25rem' }}>
          Your wedding, beautifully organized.
        </p>

        <div style={{ display:'flex', justifyContent:'center', gap:'1.25rem', flexWrap:'wrap', marginBottom:'1.25rem' }}>
          <a href="https://www.instagram.com/theokoiya" target="_blank" rel="noopener noreferrer" style={link}>Instagram</a>
          <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" style={link}>TikTok</a>
          <a href="mailto:support@okoiya.com" style={link}>support@okoiya.com</a>
        </div>

        <div style={{ display:'flex', justifyContent:'center', gap:'1.25rem', flexWrap:'wrap', marginBottom:'1.25rem' }}>
          <Link to="/privacy" style={link}>Privacy</Link>
          <Link to="/terms" style={link}>Terms</Link>
        </div>

        <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.75rem', color:'rgba(255,255,255,0.3)', margin:0 }}>
          © {new Date().getFullYear()} Okoiya. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
